(function() {
    'use strict';
    angular
        .module('valueconnectApp')
        .factory('AppraisalFirmRegion', AppraisalFirmRegion);

    AppraisalFirmRegion.$inject = ['$resource'];

    function AppraisalFirmRegion ($resource) {
        var resourceUrl =  'api/appraisal-firm-regions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
